// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '@/pages/HomeView.vue'
import CarsView from '@/pages/CarsView.vue'
import CarDetail from '@/pages/CarDetail.vue'
import AboutView from '@/pages/AboutView.vue'
import ContactView from '@/pages/ContactView.vue'
import SellCarView from '@/pages/SellCarView.vue'
import PrivacyPolicyView from '@/pages/PrivacyPolicyView.vue'

const router = createRouter({
    history: createWebHistory('/'),
    scrollBehavior() {
        return { top: 0 };
      },
    routes: [{
            path: '/',
            redirect: '/nl'
        },
        {
            path: '/:lang',
            component: () => import('@/App.vue'),
            children: [{
                    path: '',
                    name: 'home',
                    component: HomeView
                },
                {
                    path: 'cars',
                    name: 'cars',
                    component: CarsView
                },
                {
                    path: 'cars/:id',
                    name: 'car-detail',
                    component: CarDetail,
                    props: true
                },
                {
                    path: 'about',
                    name: 'about',
                    component: AboutView
                },
                {
                    path: 'contact',
                    name: 'contact',
                    component: ContactView
                },
                {
                    path: 'sell-car',
                    name: 'sell_car',
                    component: SellCarView
                },
                {
                    path: 'privacy-policy',
                    name: 'privacy_policy',
                    component: PrivacyPolicyView
                }
                  
            ]
        }
    ]
})

router.beforeEach((to, from, next) => {
    const supportedLanguages = ['nl', 'fr', 'en']
    const lang = to.params.lang

    document.title = to.meta.title || 'BASS MOTORS'

    if (!lang) {
        return next('/nl')
    }

    if (!supportedLanguages.includes(lang)) {
        return next('/nl')
    }

    localStorage.setItem('preferredLanguage', lang)

    next()
})

export default router